import type {
  BlockRejected,
  FriendEvent,
  FriendRejected,
  PartyEvent,
  PartyRejected,
} from '@shefira/shared';

import { uiFormat } from './text.js';

/** What the chat says when something happens to the party. */
export function partyEventText(event: PartyEvent): string {
  switch (event.kind) {
    case 'invited':
      return uiFormat('Invitation envoyée à {name}.', { name: event.name });
    case 'joined':
      return uiFormat('{name} rejoint le groupe.', { name: event.name });
    case 'left':
      return uiFormat('{name} quitte le groupe.', { name: event.name });
    case 'kicked':
      return uiFormat('{name} est exclu du groupe.', { name: event.name });
    case 'declined':
      return uiFormat("{name} décline l'invitation.", { name: event.name });
    case 'expired':
      return uiFormat("{name} n'a pas répondu à l'invitation.", { name: event.name });
    case 'leader':
      return uiFormat('{name} mène désormais le groupe.', { name: event.name });
    case 'disbanded':
      return 'Le groupe est dissous.';
  }
}

export const PARTY_REFUSAL_TEXT: Record<PartyRejected['reason'], string> = {
  invalid: 'Demande refusée.',
  'not-found': "Personne de ce nom n'est en jeu.",
  self: 'Tu ne peux pas faire ça avec toi-même.',
  'already-grouped': 'Ce joueur est déjà dans un groupe.',
  full: 'Le groupe est complet.',
  'not-leader': 'Seul le chef du groupe peut faire ça.',
  'no-invite': "Cette invitation n'est plus valable.",
  pending: 'Une invitation attend déjà sa réponse.',
  'not-in-party': "Tu n'es pas dans un groupe.",
};

/** What the chat says when something happens between friends (ADR 0033). */
export function friendEventText(event: FriendEvent): string {
  switch (event.kind) {
    case 'requested':
      return uiFormat("Demande d'ami envoyée à {name}.", { name: event.name });
    case 'declined':
      return uiFormat("{name} décline ta demande d'ami.", { name: event.name });
    case 'expired':
      return uiFormat("{name} n'a pas répondu à ta demande d'ami.", { name: event.name });
    case 'added':
      return uiFormat('{name} est maintenant ton ami.', { name: event.name });
    case 'removed':
      return uiFormat('{name} ne fait plus partie de tes amis.', { name: event.name });
    case 'online':
      return uiFormat('{name} vient de se connecter.', { name: event.name });
  }
}

export const BLOCK_REFUSAL_TEXT: Record<BlockRejected['reason'], string> = {
  invalid: 'Action refusée.',
  'not-found': 'Aucun joueur de ce nom.',
  self: 'Tu ne peux pas te bloquer toi-même.',
  'already-blocked': 'Ce joueur est déjà bloqué.',
  'not-blocked': "Ce joueur n'est pas bloqué.",
  full: 'Ta liste de joueurs bloqués est pleine.',
};

export const FRIEND_REFUSAL_TEXT: Record<FriendRejected['reason'], string> = {
  invalid: 'Demande refusée.',
  'not-found': "Personne de ce nom n'est en jeu.",
  self: 'Tu ne peux pas être ton propre ami.',
  'already-friends': 'Vous êtes déjà amis.',
  pending: 'Une demande attend déjà sa réponse.',
  full: "La liste d'amis est pleine.",
  'no-request': "Cette demande n'est plus valable.",
  'not-friends': "Ce joueur n'est pas dans tes amis.",
};
